import React, { useEffect, useState, Fragment, useRef } from 'react';
// import PropTypes from "prop-types";
import { Row, Col, Upload, Button, Radio, Select, message } from 'antd';
import {
    UploadOutlined,
    IdcardOutlined,
    // CloseOutlined,
    // EditOutlined,
} from '@ant-design/icons';
import { Button as MuiButton } from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import YFinput from '../elements/YFInput';
import { submitIdCard } from '../../api';
import useApplicationSession from '../../session/UserSession';
import { countries } from '../../utils/countries';
import { state_number, nationality as nrc_nationality, getDistrict } from '../../utils/nrc';
import profileStore from './profileStore';
const { Option } = Select;

const IdentityForm = ({ value }) => {
    const inputRef = useRef();
    // const [stateOfCountry, setSateOfCountry] = useState([]);
    const { register, handleSubmit, control, errors, setValue, setError } = useForm({
        defaultValues: {
            id_type: 'nirc',
        },
    });

    const [nationality, setNationality] = useState('nirc');
    const [frontImage, setFrontImage] = useState([]);
    const [backImage, setBackImage] = useState([]);
    const [choose_districts, setDistricts] = useState([]);

    const token = useApplicationSession();

    const onSubmit = (data) => {
        message.loading('Loading ...');
        if (data?.id_type === 'nirc') {
            const number = `${data.state_number}/${data.district}${data.nrc_national}${data.nrc_number}`;
            delete data.state_number;
            delete data.district;
            delete data.nrc_national;
            delete data.nrc_number;
            data.number = number;
        }

        //if (isEdit) {
        const formData = new FormData();
        formData.append('id_type', data.id_type);
        formData.append('number', data.number);
        let prefix = '';
        if (data.id_type === 'passport') prefix = 'passport_';

        formData.append('issue_country', data.issue_country !== undefined ? data.issue_country : value?.issue_country);

        if (value) {
            // edit state
            formData.append('_method', 'PUT');
        }
        let back_img_file = data.back_image;
        let front_img_file = data.front_image;
        if (data.id_type === 'passport') {
            back_img_file = data.passport_back_image;
            front_img_file = data.passport_front_image;
        }

        if (back_img_file !== undefined) {
            if (!isURL(back_img_file) && back_img_file.status !== 'removed') {
                formData.append(`${prefix}back_image`, back_img_file);
            }
        }
        if (front_img_file !== undefined) {
            if (!isURL(front_img_file) && front_img_file.status !== 'removed') {
                formData.append(`${prefix}front_image`, front_img_file);
            }
        }

        submitIdCard({ token: token, request: formData })
            .then((response) => {
                message.success(response.data.message);
                profileStore.reload(token);
            })
            .catch((error) => {
                if (error.errors) {
                    const nameArr = Object.keys(error.errors);
                    nameArr.forEach((key) => {
                        if (data.id_type === 'passport') {
                            if (key === 'front_image') {
                                setError(`passport_${key}`, 'notMatch', error.errors[key][0]);
                            } else if (key === 'back_image') {
                                setError(`passport_${key}`, 'notMatch', error.errors[key][0]);
                            } else {
                                setError(key, 'notMatch', error.errors[key][0]);
                            }
                        } else {
                            setError(key, 'notMatch', error.errors[key][0]);
                        }
                    });
                }
            });
    };

    const isURL = (str) => {
        var pattern = new RegExp(
            '^(https?:\\/\\/)?' + // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                '(\\#[-a-z\\d_]*)?$',
            'i'
        ); // fragment locator
        return !!pattern.test(str);
    };

    const forntImageProps = {
        listType: 'picture',
        beforeUpload: (file) => {
            setFrontImage([...frontImage, file]);
            return false;
        },
        onRemove: () => {
            setValue('front_image', undefined);
            setValue('passport_front_image', undefined);
            setFrontImage([]);
        },
        frontImage,
    };

    const backImageProps = {
        listType: 'picture',
        beforeUpload: (file) => {
            setBackImage([...backImage, file]);
            return false;
        },
        onRemove: () => {
            setValue('back_image', undefined);
            setValue('passport_back_image', undefined);
            setBackImage([]);
        },
        backImage,
    };

    useEffect(() => {
        if (value === null) {
            //setEdit(true);
        } else {
            const values = [];
            const keys = Object.keys(value);
            keys.forEach((key) => {
                values.push({ [key]: value[key] });
            });

            if (value.id_type === 'nirc') {
                values.push({ state_number: value.district_no });
                values.push({ district: value.district });
                values.push({ nrc_national: value.marker });
                values.push({ nrc_number: value.nrc_number });
            }
            setValue(values);
            setNationality(value.id_type);
        }
    }, [value, setValue]);

    const renderForeigner = ({ id_card }) => {
        return (
            <Fragment>
                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                        xxl={{ span: 24 }}
                        className="horizontal-container"
                    >
                        <YFinput
                            defaultValue={id_card && id_card?.id_type === 'passport' ? id_card?.number : ''}
                            name="number"
                            type="text"
                            label="Passtport number"
                            placeholder="Enter passport number"
                            rows={10}
                            register={register({ required: true, maxLength: 10 })}
                        />
                        <div className="form-error">
                            {errors.number?.type === 'required' && (
                                <span className="formFieldError">Please enter your passport number.</span>
                            )}
                            {errors.number?.type === 'maxLength' && (
                                <span className="formFieldError">Passport character length must be 8.</span>
                            )}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 24 }}
                        xl={{ span: 24 }}
                        xxl={{ span: 24 }}
                        className="horizontal-container"
                    >
                        <label htmlFor="country">Country</label>
                        <Controller
                            name="issue_country"
                            as={
                                <Select
                                    showSearch
                                    defaultValue={id_card?.issue_country}
                                    className="yf-select"
                                    style={{ width: '100%' }}
                                    placeholder="Select Issued Country"
                                    ref={inputRef}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {countries.map((item) => {
                                        return (
                                            <Option value={item.value} key={item.id}>
                                                {item.label}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            }
                            onChange={([selected]) => {
                                // setSateOfCountry(getStateOfCountry(selected));
                                return selected;
                            }}
                            rules={{
                                required: {
                                    value: id_card?.issue_country ? false : true,
                                    message: 'Please enter country',
                                },
                            }}
                            control={control}
                        />
                        <div className="form-error">
                            {errors.issue_country?.type === 'required' && (
                                <span className="formFieldError"> Please select your issued country. </span>
                            )}
                        </div>
                    </Col>
                </Row>

                <Row className="horizontal-container">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <Controller
                            name="passport_front_image"
                            as={
                                <Upload {...forntImageProps} accept="image/*" multiple={false}>
                                    <Button disabled={frontImage.length === 1}>
                                        <UploadOutlined /> Upload front image
                                    </Button>
                                </Upload>
                            }
                            control={control}
                            onChange={([data]) => {
                                return data.file;
                            }}
                            rules={{ required: id_card && id_card.passport_front_image ? false : true }}
                        />

                        {errors.passport_front_image && (
                            <span className="formFieldError"> Please upload your front image. </span>
                        )}
                        {id_card?.passport_front_image && renderImage(id_card?.passport_front_image)}
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 12 }}
                        lg={{ span: 12 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                        className="horizontal-container-element"
                    >
                        <Controller
                            name="passport_back_image"
                            as={
                                <Upload style={{ width: '100%' }} {...backImageProps} accept="image/*" multiple={false}>
                                    <Button disabled={backImage.length === 1}>
                                        <UploadOutlined /> Upload back image
                                    </Button>
                                </Upload>
                            }
                            control={control}
                            onChange={([data]) => {
                                return data.file;
                            }}
                            rules={{ required: id_card && id_card?.passport_back_image ? false : true }}
                        />

                        {errors.passport_back_image && (
                            <span className="formFieldError"> Please upload your back image. </span>
                        )}
                        {id_card?.passport_back_image && renderImage(id_card?.passport_back_image)}
                    </Col>
                </Row>
            </Fragment>
        );
    };

    const renderLocal = ({ id_card }) => {
        return (
            <Fragment>
                <Row className="horizontal-container identificationNricContainerContent">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 4 }}
                        xl={{ span: 4 }}
                        xxl={{ span: 4 }}
                        className="identificationNricContainerContentTitle"
                    >
                        <label>NRC</label>
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 5 }}
                        lg={{ span: 5 }}
                        xl={{ span: 5 }}
                        xxl={{ span: 5 }}
                        className="horizontal-container"
                    >
                        <Controller
                            name="state_number"
                            as={
                                <Select
                                    id="profile_id_state"
                                    showSearch
                                    defaultValue={id_card?.district_no}
                                    className="yf-select"
                                    style={{ width: '100%' }}
                                    placeholder="Select"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {state_number.map((item) => {
                                        return (
                                            <Option value={item.value} key={item.id}>
                                                {item.label}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            }
                            onChange={([selected]) => {
                                setDistricts(getDistrict(selected));
                                const resetValue = [
                                    { district: undefined },
                                    { nrc_national: undefined },
                                    { nrc_number: undefined },
                                ];
                                setValue(resetValue);
                                return selected;
                            }}
                            rules={{ required: true }}
                            control={control}
                        />
                        {errors.state_number?.type === 'required' && (
                            <span className="formFieldError">Please select.</span>
                        )}
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 5 }}
                        lg={{ span: 5 }}
                        xl={{ span: 5 }}
                        xxl={{ span: 5 }}
                        className="horizontal-container"
                    >
                        <Controller
                            name="district"
                            as={
                                <Select
                                    id="profile_id_district"
                                    showSearch
                                    className="yf-select"
                                    style={{ width: '100%' }}
                                    placeholder="Select"
                                    defaultValue={id_card?.district}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {choose_districts.map((item) => {
                                        return (
                                            <Option value={item.value} key={item.value}>
                                                {item.label}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            }
                            onChange={([selected]) => {
                                return selected;
                            }}
                            rules={{ required: true }}
                            control={control}
                        />
                        {errors.district?.type === 'required' && <span className="formFieldError">Please select.</span>}
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 5 }}
                        lg={{ span: 5 }}
                        xl={{ span: 5 }}
                        xxl={{ span: 5 }}
                        className="horizontal-container"
                    >
                        <Controller
                            name="nrc_national"
                            as={
                                <Select
                                    id="profile_nrc_national"
                                    showSearch
                                    className="yf-select"
                                    style={{ width: '100%' }}
                                    defaultValue={id_card?.marker}
                                    placeholder="Select"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {nrc_nationality.map((item) => {
                                        return (
                                            <Option value={item.value} key={item.value}>
                                                {item.label}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            }
                            onChange={([selected]) => {
                                return selected;
                            }}
                            rules={{ required: true }}
                            control={control}
                        />
                        {errors.nrc_national?.type === 'required' && (
                            <span className="formFieldError">Please select.</span>
                        )}
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 5 }}
                        lg={{ span: 5 }}
                        xl={{ span: 5 }}
                        xxl={{ span: 5 }}
                        className="horizontal-container"
                    >
                        <YFinput
                            name="nrc_number"
                            type="number"
                            defaultValue={id_card?.nrc_number}
                            label=""
                            placeholder="Enter NRC No"
                            register={register({ required: true, maxLength: 6 })}
                        />
                        {errors.nrc_number?.type === 'required' && (
                            <span className="formFieldError">Please enter nrc number.</span>
                        )}
                        {errors.nrc_number?.type === 'maxLength' && (
                            <span className="formFieldError">nrc number length must be 6.</span>
                        )}
                    </Col>
                </Row>

                <Row className="horizontal-container identificationNricContainerContent">
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 4 }}
                        xl={{ span: 4 }}
                        xxl={{ span: 4 }}
                        className="identificationNricContainerContentTitle"
                    >
                        <label>NRC Card Image</label>
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 10 }}
                        lg={{ span: 10 }}
                        xl={{ span: 10 }}
                        xxl={{ span: 10 }}
                        className="horizontal-container-element"
                    >
                        <Controller
                            name="front_image"
                            as={
                                <Upload
                                    id="profile-identification-local-front-image"
                                    {...forntImageProps}
                                    accept="image/*"
                                    multiple={false}
                                >
                                    <Button disabled={frontImage.length === 1}>
                                        <UploadOutlined /> Upload front image
                                    </Button>
                                </Upload>
                            }
                            control={control}
                            onChange={([data]) => {
                                return data.file;
                            }}
                            rules={{ required: id_card && id_card?.front_image ? false : true }}
                        />

                        {errors.front_image && (
                            <span className="formFieldError"> Please upload your front image. </span>
                        )}

                        {id_card?.front_image && renderImage(id_card?.front_image)}
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 10 }}
                        lg={{ span: 10 }}
                        xl={{ span: 10 }}
                        xxl={{ span: 10 }}
                        className="horizontal-container-element"
                    >
                        <Controller
                            name="back_image"
                            as={
                                <Upload
                                    id="profile-identification-local-back-image"
                                    style={{ width: '100%' }}
                                    {...backImageProps}
                                    accept="image/*"
                                    multiple={false}
                                >
                                    <Button disabled={backImage.length === 1}>
                                        <UploadOutlined /> Upload back image
                                    </Button>
                                </Upload>
                            }
                            control={control}
                            onChange={([data]) => {
                                return data.file;
                            }}
                            rules={{ required: id_card && id_card?.back_image ? false : true }}
                        />
                        {errors.back_image && <span className="formFieldError"> Please upload your back image. </span>}
                        {id_card?.back_image && renderImage(id_card?.back_image)}
                    </Col>
                </Row>
            </Fragment>
        );
    };

    const renderImage = (img) => {
        return (
            <div className="licenseImageContainer">
                <img
                    className="licensePreviewImage"
                    // style={{ width: 100, height: 300, objectFit: "contain" }}
                    src={img}
                    alt="id-card"
                />
            </div>
        );
    };

    // const onNext = () => {
    //   history.push({
    //     pathname: `${SUBSCRIPTION_DECLARATION}`,
    //     search: location.search,
    //   })
    // }

    // const onBack = () => {
    //   history.push({
    //     pathname: `${SUBSCRIPTION_EMPLOYEE}`,
    //     search: location.search,
    //   })
    // }

    return (
        <div className="formStatus">
            <form className="payment-information-form" onSubmit={handleSubmit(onSubmit)}>
                <div className="payment-information-label-container">
                    <IdcardOutlined className="personal-information-icon" style={{ fontSize: 20, padding: 10 }} />
                    <h4 className="payment-information-label">Identification</h4>
                </div>
                <Row>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 4 }}
                        xl={{ span: 4 }}
                        xxl={{ span: 4 }}
                        className="horizontal-container"
                    >
                        <label>Nationality</label>
                    </Col>
                    <Col
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 20 }}
                        xl={{ span: 20 }}
                        xxl={{ span: 20 }}
                        className="horizontal-container"
                    >
                        <Controller
                            name="id_type"
                            as={
                                <Radio.Group>
                                    <Radio value="nirc">Local</Radio>
                                    <Radio value="passport">Foreigner</Radio>
                                </Radio.Group>
                            }
                            control={control}
                            onChange={([event]) => {
                                setNationality(event.target.value);
                                setFrontImage([]);
                                setBackImage([]);
                                return event.target.value;
                            }}
                            rules={{ required: false }}
                        />
                        {errors?.property?.type === 'required' && (
                            <span className="formFieldError">Please select your experience</span>
                        )}
                    </Col>
                </Row>

                <div className="idenficationContainer">
                    {nationality === 'nirc' ? renderLocal({ id_card: value }) : renderForeigner({ id_card: value })}
                </div>

                <div className="subscriptionContentContainerSteps">
                    {/* <MuiButton onClick={() => onBack()} className="secondary-btn profilePrev">back</MuiButton> */}
                    <MuiButton className="secondary-btn profileNext" type="submit">
                        save
                    </MuiButton>
                </div>
                {/* )} */}
            </form>

            {/* <Affix offsetBottom={0}>
        <div className="formStepper">
          <img src={car} alt="Car" className="formStepperCar step4" />
          <img src={road} alt="Road" className="formStepperRoad" />
        </div>
      </Affix> */}
        </div>
    );
};

export default IdentityForm;
